import React, { useState, useEffect } from 'react';
import * as S from './filters.styles';
import ReactSlider from 'react-slider';
import * as S1 from '../../Common/common-elements.styles';

const Duration = props => {
  const {
    title,
    durationFilters,
    updateFilter,
    minDuration,
    maxDuration,
    filterType,
    handleResetIndividualFilter,
    isLoading
  } = props;
  const [filterValues, setFilterValues] = useState(maxDuration);

  useEffect(() => {
    setFilterValues(maxDuration);
  }, [maxDuration]);

  useEffect(() => {
    if (durationFilters[0] && durationFilters[0].max) {
      setFilterValues(durationFilters[0].max);
    } else {
      setFilterValues(maxDuration);
    }
  }, [durationFilters]);

  if (isLoading) {
    return (
      <div className="flexCol">
        <div className="dF justifyBetween quicksand">
          <div className="black fb font14 padB10 quicksand">{title}</div>
          <S.Reset
            clickable={durationFilters.length}
            onClick={() => handleResetIndividualFilter(filterType)}
          >
            Reset
          </S.Reset>
        </div>
        <div className="flexCol padT35 padB20">
          <S1.AnimatedBackground className="width100 padT10 padB10 "></S1.AnimatedBackground>
        </div>
      </div>
    );
  }

  const OnAfterChangeHandler = currMaxDuration => {
    updateFilter(filterType, { min: minDuration, max: currMaxDuration });
  };

  const getDurationForDisplay = dur => {
    let duration = +dur / 60;
    let hours = Math.floor(duration);
    let minutes = ((duration - hours) * 60).toFixed(0);

    return `${hours ? `${hours}h` : ''} ${minutes}m`;
  };

  return (
    <>
      <div className="flexCol">
        <div className="dF justifyBetween quicksand">
          <div className="black fb font14 padB10 quicksand">{title}</div>
          <S.Reset
            clickable={durationFilters.length}
            onClick={() => handleResetIndividualFilter(filterType)}
          >
            reset
          </S.Reset>
        </div>
        <div className="flexCol padT10 padB10">
          {/* <br />
          <S.FltSldBase>
            <ReactSlider
              className="fltSld-target"
              thumbClassName="fltSld-handle"
              trackClassName="fltSld-connect"
              defaultValue={[minDuration, maxDuration]}
              value={filterValues}
              min={minDuration}
              max={maxDuration}
              renderThumb={(props, state) => (
                <div {...props}> {getDurationForDisplay(state.valueNow)} </div>
              )}
              pearling
              minDistance={1}
              onAfterChange={OnAfterChangeHandler}
            />
          </S.FltSldBase> */}
          <S.TripSlider>
            <ReactSlider
              className="fltSld-target"
              thumbClassName="fltSld-handle"
              trackClassName="fltSld-connect"
              defaultValue={[maxDuration]}
              value={filterValues}
              min={minDuration}
              max={maxDuration}
              renderThumb={(props, state) => (
                <div {...props}> {getDurationForDisplay(state.valueNow)} </div>
              )}
              onAfterChange={OnAfterChangeHandler}
              minDistance={1}
            />
            <p className="dF quicksand justifyBetween grey fb font12 marginT15">
              <span>{getDurationForDisplay(minDuration)}</span>
              <span>{getDurationForDisplay(maxDuration)}</span>
            </p>
          </S.TripSlider>
        </div>
        <div className="flexCol"></div>
      </div>
    </>
  );
};
export default Duration;
